module.exports = __webpack_public_path__ + "static/media/Giraffe Guy.e110aa3f.jpg";